export const UPDATE_AUTH_NAMES_LIST = 'UPDATE_AUTH_NAMES_LIST';







